import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CheckoutData } from '../../../domain/registrator';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { BlankOrNAPipe } from '../../../pipes/blank-or-na.pipe';
import { IsBlankPipe } from '../../../pipes/is-blank.pipe';

@Component({
  selector: 'app-confirm-checkout-dialog',
  imports: [CommonModule, MatDialogModule, MatCardModule, MatButtonModule, BlankOrNAPipe, IsBlankPipe],
  templateUrl: './confirm-checkout-dialog.component.html',
  styleUrl: './confirm-checkout-dialog.component.scss'
})
export class ConfirmCheckoutDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: CheckoutData) {}
}
